import AuditWorkflowDetail from './src/main';

/* istanbul ignore next */
AuditWorkflowDetail.install = function(Vue) {
  Vue.component(AuditWorkflowDetail.name, AuditWorkflowDetail);
};

export default AuditWorkflowDetail;
